import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormFeedback,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { userCan } from '../../helpers/Auth';

import CollectionSelectModal from '../CollectionSelectModal';

const ImporterModalCollection = ({
  selectedCollection,
  selectedCollectionError,
  setSelectedCollection,
}) => {
  const intl = useIntl();

  const [collectionSelectOpen, setCollectionSelectOpen] = useState(false);

  return (
    <>
      {selectedCollectionError && (
        <>
          <i id="selected-collection-error" className="error-icon far fa-circle-exclamation fa-2x" />
          <UncontrolledTooltip target="selected-collection-error">
            {intl.formatMessage({
              defaultMessage: `Please select or create a Collection for your imported files.
                You can move these files after the import is complete.`,
            })}
          </UncontrolledTooltip>
        </>
      )}
      <div className={`modal-import-selected-collection${selectedCollectionError ? ' selected-collection-error' : ''}`}>
        {intl.formatMessage({ defaultMessage: 'Import to' })}{' '}
        <a
          href="#collection"
          onClick={(e) => {
            e.preventDefault();
            setCollectionSelectOpen(true);
          }}
        >
          {selectedCollection ? (
            selectedCollection.name
          ) : (
            <span>{intl.formatMessage({ defaultMessage: '(select collection)' })}</span>
          )}
          <i className="far fa-chevron-down" />
        </a>
        <FormFeedback>
          {intl.formatMessage({ defaultMessage: 'Please select or create a Collection' })}
        </FormFeedback>
        <CollectionSelectModal
          modalOpen={collectionSelectOpen}
          enableAddNew={userCan('collection.create')}
          onlyOpenCollections={true}
          selectedCollectionUuid={selectedCollection ? selectedCollection.uuid : null}
          handleClose={() => { setCollectionSelectOpen(false); }}
          handleCollectionSelect={setSelectedCollection}
          smartCollectionsRestrict={false}
          showSmartSection={false}
        />
      </div>
    </>
  );
};

ImporterModalCollection.propTypes = {
  selectedCollection: PropTypes.object,
  selectedCollectionError: PropTypes.bool.isRequired,
  setSelectedCollection: PropTypes.func.isRequired,
};

ImporterModalCollection.defaultProps = {
  selectedCollection: null,
};

export default ImporterModalCollection;
